import { useTranslation } from 'react-i18next';
import { array, mixed, string, number, object } from 'yup';
import { EventBiogenBrand } from 'modules/events/basics/enums/biogen.enum';

const usePrimaryInformationsSchema = () => {
  const { t } = useTranslation();
  const requiredLabel = t('form_errors_required');
  const maxDescriptionLength = 4000;
  const maxLengthDescriptionMessage = `${t('events_description_input_max_length_error_message', { count: maxDescriptionLength })}`;

  const maxTitleLength = 250;
  const maxLengthTitleMessage = `${t('events_title_input_max_length_error_message', { count: maxTitleLength })}`;

  return {
    title: string()
      .required()
      .max(maxTitleLength, maxLengthTitleMessage),
    description: string()
      .nullable(true)
      .max(maxDescriptionLength, maxLengthDescriptionMessage),
    product: mixed<EventBiogenBrand>()
      .oneOf(Object.values(EventBiogenBrand), requiredLabel)
      .required(),
    program: array()
      .nullable(true)
      .of(object().shape({
        id: string().required(),
        programName: string().required(),
        programLogo: array()
          .nullable(true)
          .of(object().shape({
            name: string().required(),
            url: string().required(),
          })),
      })),
    cardImage: array()
      .nullable(true)
      .of(object().shape({
        id: string().required(),
        size: number().required(),
        name: string().required(),
        url: string().required(),
      })),
  };
};

export default usePrimaryInformationsSchema;
